var app = angular.module('leonardo');

var PropertyTasks = function ($scope, $rootScope, $timeout, $state, FilterService, PropertyService, PermissionService) {
  $scope.loading = true;

  $scope.filterService = FilterService;
  $scope.permissionService = PermissionService;

  $scope.canEditProperty = PermissionService.permissionAvailable('permission_edit_property', FilterService.currentProperty);
  $scope.canViewProperty = PermissionService.permissionAvailable('permission_read_only_property', FilterService.currentProperty);

  $scope.goToPropertyAttributes = function () {
    if ($scope.canEditProperty || $scope.canViewProperty) {
      $state.go('portfolios.property-edit', { pk: FilterService.currentProperty.id });
    }
  };

  $scope.initLoading = function () {
    if (FilterService.currentProperty) {
      $scope.loading = FilterService.currentProperty.loading;
      if ($scope.loading) {
        var options = {};
        if (FilterService.hasFilter('role')) {
          options['roles'] = FilterService.getFilter('role');
        }
        PropertyService.get(FilterService.currentProperty.id, options).then(function (data) {
          FilterService.currentProperty = data;
        });
      }
    }
  };

  $scope.goPastDue = function () {
    $rootScope.$broadcast('no_reset_filters:updated', true);
    if ($state.$current.name === 'owner-tasks.tasks') {
      $state.go('owner-tasks.past-due');
    } else {
      $state.go('property.past-due');
    }
  };

  $scope.goCurrent = function () {
    $rootScope.$broadcast('no_reset_filters:updated', true);
    if ($state.$current.name === 'owner-tasks.past-due') {
      $state.go('owner-tasks.tasks');
    } else {
      $state.go('property.tasks');
    }
  };
};

app.controller('PropertyTasks', [
  '$scope',
  '$rootScope',
  '$timeout',
  '$state',
  'FilterService',
  'PropertyService',
  'PermissionService',
  PropertyTasks
]);
